export type ISubjectPublicationClaimsWhereInput = {
  entityId: number;
  state?: string;
  opengovId?: number;
  title?: string;
  userAndGroupIds?: string[];
};

export type ISubjectPublicationClaimsWhereClause = {
  entityId?: { _eq: number; };
  status?: { _eq: string; };
  title?: { _ilike: string; };
  createdByUser?: { opengovId: { _eq: number } };
  subjectPublicationClaims?: { subjectId: { _in: string[]; }; };
}

export const buildWhereClauseForSubjectPublicationClaims = ({
  entityId,
  state,
  opengovId,
  title,
  userAndGroupIds,
}: Partial<ISubjectPublicationClaimsWhereInput>): ISubjectPublicationClaimsWhereClause => {
  const where: ISubjectPublicationClaimsWhereClause = {}
  if(entityId) {
    where.entityId = { _eq: entityId }
  };

  if (state) {
    where.status = { _eq: state };
  }

  if (title) {
    where.title = { _ilike: title };
  }

  if (opengovId) {
    where.createdByUser = {
      opengovId: { _eq: opengovId }
    };
  }

  if (userAndGroupIds?.length) {
    where.subjectPublicationClaims = {
      subjectId: { _in: userAndGroupIds }
    };
  }

  return where;
};
